import { ArrowDown, Check, Country } from '@tencent/odc-iconpack';
import { DropMenu } from 'odc-shared/components';
import { ELanguage } from 'odc-shared/i18n';
import { useState } from 'react';

import { SUPPORT_CENTER_LANGUAGES, getLanguageLabel } from '../../constants/language';

interface LanguageSwitcherProps {
  /** 当前语言（界面语言与内容语言同步，由页面按 URL 传入） */
  value: string;
  onChange: (next: ELanguage) => void;
}

/**
 * Help Center Header 右侧语言切换器。
 *
 * 语言项即"自我标识"（English / 中文），不随界面语言翻译；
 * 选项列表来自 SUPPORT_CENTER_LANGUAGES —— 未启用中文时该组件不会被渲染（见页面门控）。
 */
const LanguageSwitcher = ({ value, onChange }: LanguageSwitcherProps) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <DropMenu
      data={SUPPORT_CENTER_LANGUAGES.map((language) => ({
        value: language,
        label: (
          <div className="odc-language-menu-item">
            {getLanguageLabel(language)}
            {value === language && <Check className="!text-md" />}
          </div>
        ),
      }))}
      offsetData={{
        top: -8,
      }}
      dropdownPortalClassName="odc-language-dropmenu"
      onClick={(next: number | string) => {
        onChange(next as ELanguage);
        setOpen(false);
      }}
      open={open}
      onOpen={(next) => setOpen(next)}
      trigger="click"
      matchTriggerWidth
    >
      <div className="odc-language-trigger">
        <Country className="text-base" />
        <span className="!ml-1r font-normal">{getLanguageLabel(value)}</span>
        <ArrowDown className="!ml-1r text-base" />
      </div>
    </DropMenu>
  );
};

export default LanguageSwitcher;
